/*eslint-disable*/

import React from 'react';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { api_url } from '../../../Constants/web_services';
import { useSelector } from 'react-redux';
import { selectUserData } from '../../../Redux/UserSlice';
import Swal from 'sweetalert2';

function Payment({ order }) {
    const stripe = useStripe();
    const elements = useElements();
    // const userData = useSelector(selectUserData);

    const handleStripe = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) {
            return;
        }

        try {
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

            const result = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: api_url + `/api/confirm-payment/user/order/${order?.id}/company/${order?.company?.id}/amount/${order?.payment}`,
                },
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Accept': 'application/json',
                },
            });

            if (result.error) {
                // Show error alert using Swal.fire
                Swal.fire({
                    icon: 'error',
                    title: 'Payment Error',
                    text: result.error.message,
                });
            } else {
                // Show success alert using Swal.fire
                Swal.fire({
                    icon: 'success',
                    title: 'Payment Successful',
                    text: 'Your payment has been successfully processed.',
                }).then(() => {
                    // Optionally, redirect user after successful payment
                    window.location.href = result.paymentIntent.return_url; // Redirect to the specified URL
                });
            }
        } catch (error) {
            console.error("Error processing payment:", error);
            Swal.fire({
                icon: 'error',
                title: 'Payment Error',
                text: 'An unexpected error occurred. Please try again later.',
            });
        }
    };

    return (
        <div className="row justify-content-center mt-5">
            <div className="col-md-6">
                <div className="card p-4">
                    <h2>Note</h2>
                    <h6 className='text-uppercase text-center text-danger fw-800'>10% is deducted after three days of order payment</h6>
                    <p>5555555555554444</p>
                    <form onSubmit={handleStripe}>
                        <PaymentElement />
                        <button className='btn btn-primary w-100 mt-3' disabled={!stripe} type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Payment;
